exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".whitelink{width:100%;background-color:#fff;border-radius:5px;color:#4A4A4A;box-sizing:border-box;display:flex;flex-direction:row;align-content:center;align-items:center;text-decoration:none;padding:15px;border:solid thin #D8D8D8;margin-bottom:15px;box-shadow:0px 0px 3px #D8D8D8;padding-left:30px;cursor:pointer}.whitelink.report{padding:20px;border:none}.whitelink .whitelink-text{flex:1;font-family:'SF-Pro-Display-Regular';font-size:16px}.whitelink .whitelink-text p{margin:0;color:#898989;font-size:14px;font-family:'SF-Pro-Display-Regular'}.whitelink .whitelink-icon{display:flex;flex-direction:row;align-content:center;align-items:center}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss"}!./src/components/WhiteLink/style.scss
// module id = 1549
// module chunks = 0